module.exports = __webpack_public_path__ + "static/media/Cientista2.d123fccd.png";